export const DOMAIN_COUNTRY_MAP: { [key: string]: string } = {
    'http://localhost:3031': 'FSA',
    'http://localhost:3000': 'FSA',
    'https://me.cleartrip.ae': 'AE',
    'https://www.cleartrip.ae': 'AE',

    'https://om.cleartrip.com': 'OM',
    'https://om.cleartrip.sa': 'OM',
    'https://www.cleartrip.om': 'OM',
    'https://qa2om.cleartrip.com': 'OM',

    'https://qar.cleartrip.sa': 'QA',
    'https://www.cleartrip.qa': 'QA',
    'https://qa.cleartrip.com': 'QA',
    'https://qa2qa.cleartrip.com': 'QA',

    'https://bh.cleartrip.sa': 'BH',
    'https://www.cleartrip.bh': 'BH',
    'https://bh.cleartrip.com': 'BH',
    'https://qa2bh.cleartrip.com': 'BH',

    'https://kw.cleartrip.com': 'KW',
    'https://qa2kw.cleartrip.com': 'KW',
    'https://kw.cleartrip.sa': 'KW',
    'https://www.cleartrip.com.kw': 'KW',
    'https://www.cleartrip.kw': 'KW',

    'https://www.cleartrip.sa': 'SA',
    'https://qa2.cleartrip.sa': 'SA',
    'https://me.cleartrip.sa': 'SA',
    'https://www.flyin.com': 'FSA',
    'https://eg.flyin.com': 'FEG',
    'https://ae.flyin.com': 'FAE',

    'https://me.flyin.com': 'FSA',
    'https://meeg.flyin.com': 'FEG',
    'https://meae.flyin.com': 'FAE'
}

export const DOMAIN = typeof window !== 'undefined' ? window.location.origin : 'https://www.cleartrip.ae'

export const domainCountry = DOMAIN_COUNTRY_MAP[DOMAIN as keyof typeof DOMAIN_COUNTRY_MAP] || 'AE'
